/* eslint-disable no-param-reassign */
export const singlePropReducer =
	(name, defaultValue) =>
	(state, { payload } = { payload: defaultValue }) => {
		state[name] = payload;
	};

export const singlePropUpdateReducer =
	(name, defaultValue) =>
	(state, { payload } = { payload: defaultValue }) => {
		state[name] = { ...state[name], ...payload };
	};
